import ActiveConfiguration from './ActiveConfiguration'
import AppliedLicenses from './AppliedLicenses'
import LastHomeBackup from './LastHomeBackup'
import SoftwareVersion from './SoftwareVersion'
import HomeUsers from './HomeUsers'
import { SubInfoContainer } from './styles'
import SubscriptionInfoBlock from './SubscriptionInfo'
import ConnectedApps from './ConnectedApps'
import HostInfo from './HostInfo'

interface SubInfoProps {
  lastBackup: number | null
}

function SubInfo({ lastBackup }: SubInfoProps) {
  return (
    <SubInfoContainer>
      <HostInfo />
      <SoftwareVersion />
      <ActiveConfiguration />
      <SubscriptionInfoBlock isHomeDashboard />
      <HomeUsers />
      <LastHomeBackup lastBackup={lastBackup} />
      {/* 
        Hide block "Support" as we dont have it in this release!
        CENTRAL-1121
        <UserSupport /> 
      */}
      <AppliedLicenses />
      <ConnectedApps />
    </SubInfoContainer>
  )
}

export default SubInfo
